import { createAsyncThunk } from '@reduxjs/toolkit';
import { ImagerQuotaDTO } from 'business/models/Models';
import ImagerQuotaService from 'business/services/ImagerQuotaService';

export const getAllImagerQuota = createAsyncThunk('getAllImagerQuota', async () => {
  const dataService = new ImagerQuotaService();
  return await dataService.getAllImagerQuota();
});

export const saveImagerQuota = createAsyncThunk(
  'saveImagerQuota',
  async (imagerQuotaList: ImagerQuotaDTO[], thunkApi) => {
    const dataService = new ImagerQuotaService();
    return await dataService.saveImagerQuota(imagerQuotaList);
  },
);
